import { Link } from '@tanstack/react-router';

import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { useAuth } from '@/hooks/useAuth';

export function TeamSwitcher() {
  const { user } = useAuth();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          asChild
          tooltip="Oubo Platform"
          className="gap-3 group-data-[collapsible=icon]:mx-auto group-data-[collapsible=icon]:p-0!"
        >
          <Link to="/admin/dashboard">
            <img
              src="/oubo-logo.webp"
              alt="Oubo"
              className="size-9 shrink-0 rounded-lg object-cover shadow-sm group-data-[collapsible=icon]:size-8"
              loading="lazy"
            />
            <div className="grid flex-1 text-left leading-tight">
              <span className="truncate text-sm font-semibold tracking-tight">Oubo Platform</span>
              <span className="truncate text-xs capitalize text-muted-foreground">
                {user?.role ?? 'Admin'} workspace
              </span>
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
